import { encounterField } from '../../shared/array-types.js';
import { statusRows } from '../statuses/expiry.js';
import { readInventoryField } from '../compile/inventory-raw-readers.js';
import { readItemField } from '../compile/item-field-reader.js';
import { appliedStatusRows } from './applied-status-rows.js';
import { record, upper, type Row, type StatusRow } from '../ability/context.js';
/** Install only changed encounter/floor status rows. Members keep the existing derived-cluster projector. */
export function projectNoncreatureStatuses(encounter: Row, added: readonly StatusRow[], removed: readonly { target: string; status_item_id: string; status_id?: string }[],
  campaign: Row | null, definition: (id: string) => Row | null): void {
  const ids = new Set([...added.map(row => upper(row.target)), ...removed.map(row => upper(row.target))]);
  const targets = new Map<string, Row>();
  const eid = upper(encounterField(encounter, 'encounter_id'));
  if (ids.has(eid)) targets.set(eid, encounter);
  if (Array.isArray(encounter.encounter_inventories_arr)) for (const target of encounter.encounter_inventories_arr as Row[]) {
    const id = upper(readInventoryField(target, 'inventory_id')); if (ids.has(id)) targets.set(id, target);
  }
  const saved = new Map(appliedStatusRows(added, campaign).map(change => [change.row_id, change.row]));
  for (const [id, target] of targets) {
    let rows = statusRows(target, 'target').filter(row => !removed.some(change => upper(change.target) === id
      && (change.status_id ? upper(readItemField(row, 'status_id')) === upper(change.status_id)
        : upper(readItemField(row, 'status_item_id')) === upper(change.status_item_id))));
    for (const status of added) if (upper(status.target) === id) {
      rows = rows.filter(row => upper(readItemField(row, 'status_id')) !== upper(status.status_id));
      rows.push({ ...status, ...saved.get(upper(status.status_id)), status_target_id: id, status_caster_id: upper(status.caster),
        status_arr: definition(upper(status.status_item_id)) });
    }
    target.statuses = { ...record(target.statuses), target: rows };
  }
}
